import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { OrdenPestanas, PestanasModificables } from '@app/shared';
import { filter } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OpcionesEspeciales } from '../view-form/view-form.component';
import { ModifyWindowConfigService } from './shared/modify-window.config.service';

@Component({
  selector: 'iw-modify-window',
  templateUrl: './modify-window.component.html',
  styleUrls: ['./modify-window.component.scss']
})
export class ModifyWindowComponent implements OnInit {
  // Referencia a la modal
  modalRef: BsModalRef;
  // Contiene la configuracion de la tabla
  settings: any = {};
  // Contiene los registros de la tabla
  source: LocalDataSource;
  // Define si la forma tiene la propieda de gestion de documentos
  @Input() documentManagement: boolean;
  // Define si la forma tiene la propiedad de radicacion
  @Input() radication: boolean;
  // Define si la forma tiene la propieda de anexos
  @Input() annexed: boolean;
  // Define si la forma tiene la propieda de revisiones
  @Input() revisions: boolean;
  // Define si la forma tiene la propieda de radicación especial
  @Input() special_radication: boolean;
  // Define si la forma tiene la propieda de con copia a funcionarios
  @Input() functionary: boolean;
  // Define si la forma tiene la propieda de enviado por
  @Input() sendedBy: boolean;
  // Define si la forma tiene la propieda de revision
  @Input() remision: boolean;
  // define la pestaña de formularios
  formularios = true;
  // Informacion del formulario
  @Input() dataForm: OpcionesEspeciales;
  // Contiene el orden de las péstañas
  tabs: PestanasModificables[] = [];
  // Referencia al template de la modal
  @ViewChild('templateModal') private templateModal: TemplateRef<any>;
  // Salida de las pestañas modificables
  @Output() modifiable_windows: EventEmitter<any[]> =  new EventEmitter();

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
    const config = new ModifyWindowConfigService();
    this.settings = config.settings;
  }

  /**
   *Abre la modal con la tabla
   *
   * @memberof ModifyWindowComponent
   */
  open() {
    this.modalRef = this.modalService.show(this.templateModal, { class: 'modal-lg'});
    if(this.dataForm && this.dataForm.pestanas_modificables && this.dataForm.pestanas_modificables.length){
      if(this.documentManagement && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'formularios')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'formularios',
          orden: 0,
          pestana: 'formularios',
          requerido: false,
        })
      }
      if(this.documentManagement && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'gestion_documentos')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Generar / Subir documentos',
          orden: 0,
          pestana: 'gestion_documentos',
          requerido: false,
        })
      }
      if(this.radication && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'radicacion')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Radicar / Asociar documentos',
          orden: 0,
          pestana: 'radicacion',
          requerido: false,
        })
      }
      if(this.annexed && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'anexos')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Anexos',
          orden: 0,
          pestana: 'anexos',
          requerido: false,
        })
      }
      if(this.revisions && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'revisiones')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Aprobar / Firmar documento',
          orden: 0,
          pestana: 'revisiones',
          requerido: false,
        })
      }
      if(this.special_radication && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'radicacion_especial')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Radicación especial',
          orden: 0,
          pestana: 'radicacion_especial',
          requerido: false,
        })
      }
      if(this.functionary && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'con_copia_a')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Con copia a',
          orden: 0,
          pestana: 'con_copia_a',
          requerido: false,
        })
      }
      if(this.sendedBy && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'enviado_por')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Enviado por',
          orden: 0,
          pestana: 'enviado_por',
          requerido: false,
        })
      }
      if(this.remision && !this.dataForm.pestanas_modificables.find(x => x.pestana == 'remision_funcionarios')){
        this.dataForm.pestanas_modificables.push({
          modificable: false,
          nombre: 'Remisión funcionarios',
          orden: 0,
          pestana: 'remision_funcionarios',
          requerido: false,
        })
      }
      this.tabs = filter(this.dataForm.pestanas_modificables, el => {
        if (this.formularios && el.pestana === 'formularios') {
          return el;
        }
        if (this.documentManagement && el.pestana === 'gestion_documentos') {
          return el;
        }
        if (this.radication && el.pestana === 'radicacion') {
          return el;
        }
        if (this.annexed && el.pestana === 'anexos') {
          return el;
        }
        if (this.revisions && el.pestana === 'revisiones') {
          return el;
        }
        if(this.special_radication && el.pestana === 'radicacion_especial'){
          return el;
        }
        if(this.functionary && el.pestana === 'remision_funcionarios'){
          return el;
        }
        if(this.sendedBy && el.pestana === 'enviado_por'){
          return el;
        }
        if(this.remision && el.pestana === 'con_copia_a'){
          return el;
        }
        if (el.pestana === 'formularios') {
          return el;
        }
      });
      this.tabs.forEach((tab, i) => {
        if(!tab['modificable']){
          tab['modificable'] = false;
        }
      });
      this.source = new LocalDataSource(this.tabs);
    }
  }

  /**
   *Cierra la modal
   *
   * @memberof ModifyWindowComponent
   */
  closeModal() {
    this.tabs = [];
    this.modalRef.hide();
  }

  /**
   *Controla el evento de click sobre un registro de la tabla
   *
   * @param {*} row
   * @memberof ModifyWindowComponent
   */
  rowSelected(row: any){
    // row['data']['modificable'] = !row['data']['modificable'];
    this.tabs.forEach(t=>{
      if(t.pestana == row.data.pestana){
        t['modificable'] = !row['data']['modificable'];
      }
    })
    this.source.refresh();
    this.modifiable_windows.emit(this.tabs);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/modify-window/modify-window.component.ts